export const globalNodeCounters = new Map();
//# sourceMappingURL=globalNodeCounters.js.map